import { render } from "./PoiGz.vue?vue&type=template&id=d227ca4c&scoped=true"
import script from "./PoiGz.vue?vue&type=script&lang=js"
export * from "./PoiGz.vue?vue&type=script&lang=js"

import "./PoiGz.vue?vue&type=style&index=0&id=d227ca4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d227ca4c"]])

export default __exports__